<template>
    <div class="main">
        <c-panel title="FÓRMULAS DE CÁLCULO DE DESEMPENHO" titleIcon="fas fa-calculator">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Enquanto uma turma não estiver vinculada a uma fórmula, o cálculo continua exatamente como sempre foi. A vinculação é feita na turma ou pela aplicação em lote."></el-alert>

            <el-row class="u-mt-10 u-mb-20" :gutter="10">
                <el-col :xs="24" :sm="16" :md="16">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar fórmula..." @keyup.native.enter="load"></el-input>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/formula-calculo/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVA FÓRMULA</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 70px;">cod</th>
                            <th>Nome</th>
                            <th class="hidden-mobile" style="width: 170px;">Cálculo do período</th>
                            <th class="hidden-mobile" style="width: 170px;">Cálculo anual</th>
                            <th class="hidden-mobile u-text-center" style="width: 90px;">Média</th>
                            <th class="hidden-mobile u-text-center" style="width: 110px; text-transform: uppercase;">Situação</th>
                            <th style="width: 190px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td class="hidden-mobile">{{ item.id }}</td>
                            <td>{{ item.nome | truncate(50, '...') }}</td>
                            <td class="hidden-mobile">{{ rotulo(item.metodo_periodo) }}</td>
                            <td class="hidden-mobile">{{ rotulo(item.metodo_anual) }}</td>
                            <td class="hidden-mobile u-text-center">{{ item.media_aprovacao }}</td>
                            <td class="hidden-mobile u-text-center" style="text-transform: uppercase;">{{ item.situacao === false ? 'Inativo' : 'Ativo' }}</td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/formula-calculo/simulador/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                    <el-button type="warning" title="Simular" icon="el-icon-data-line" size="mini" plain></el-button>
                                </router-link>
                                <template v-if="podeEscrever">
                                    <router-link :to="'/admin/formula-calculo/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                        <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                    </router-link>
                                    <el-button @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="7" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum registro encontrado.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12" :md="12">
                        <div class="u-text-left u-mt-10">
                            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                @current-change="getPage" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        statusList: false,
        filtro: { nome: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: []
    }),
    computed: {
        podeEscrever () { return [4, 5, 6, 7].includes(Number(this.$store.state.user.tipo)) }
    },
    mounted () { this.load() },
    methods: {
        rotulo (v) {
            const r = {
                soma: 'Soma', media_aritmetica: 'Média aritmética', media_ponderada: 'Média ponderada',
                maior_nota: 'Maior nota', ultimo_periodo: 'Último período'
            }
            return r[v] || v
        },
        load () {
            this.statusList = false
            this.items = []
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/formula-calculo/getAllPaginate?page=${this.paginate.page}`,
                this.filtro,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.items = r.data.data
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusList = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        excluir (id) {
            this.$msgbox.confirm('Tem certeza que deseja excluir esta fórmula?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/formula-calculo/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    // O service recusa a exclusão de fórmula em uso por turma ou matriz.
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Excluído com sucesso.', type: 'success' })
                    this.load()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        getPage (page) { this.paginate.page = page; this.load() }
    }
}
</script>
